const VulnerabilitySoil = () =>
  import(
    /* webpackChunkName: "VulnerabilitySoil" */
    "@/components/ssp/missions/mission/site/partials/vulnerability/VulnerabilitySoil.vue"
  );
const VulnerabilityUndergroundWater = () =>
  import(
    /* webpackChunkName: "VulnerabilityUndergroundWater" */
    "@/components/ssp/missions/mission/site/partials/vulnerability/VulnerabilityUndergroundWater.vue"
  );
const VulnerabilitySurfaceWater = () =>
  import(
    /* webpackChunkName: "VulnerabilitySurfaceWater" */
    "@/components/ssp/missions/mission/site/partials/vulnerability/VulnerabilitySurfaceWater.vue"
  );
const VulnerabilityMeteorology = () =>
  import(
    /* webpackChunkName: "VulnerabilityMeteorology" */
    "@/components/ssp/missions/mission/site/partials/vulnerability/VulnerabilityMeteorology.vue"
  );
const VulnerabilityHeritage = () =>
  import(
    /* webpackChunkName: "VulnerabilityHeritage" */
    "@/components/ssp/missions/mission/site/partials/vulnerability/VulnerabilityHeritage.vue"
  );

export default [
  {
    path: "soil/:tab?",
    name: "soil",
    component: VulnerabilitySoil,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "underground-water/:tab?",
    name: "undergroundWater",
    component: VulnerabilityUndergroundWater,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "surface-water/:tab?",
    name: "surfaceWater",
    component: VulnerabilitySurfaceWater,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "meteorology",
    name: "meteorology",
    component: VulnerabilityMeteorology,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "heritage",
    name: "heritage",
    component: VulnerabilityHeritage,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
];
